import { useAPI, useAuthenticatedAPI } from '../../../state';
var CLIENTS_API = '/api/orgConfig/clients';
var CLIENTS_STATUS_API = '/api/orgConfig/clients/status';
var CLIENT_API = '/api/orgConfig/clients/{id}';
var TEST_CONNECTION_API = '/api/orgConfig/clients/testConnection';
var CLIENT_TEST_API = '/api/orgConfig/clients/{id}/testConnection';
var CLIENT_LOBS_API = '/api/orgConfig/clients/{id}/lobs';
var CLIENT_LOB_API = '/api/orgConfig/clients/{id}/lobs/{lobId}';
var CLIENT_SUB_LOB_API = '/api/orgConfig/clients/{id}/lobs/{lobId}/subLobs/{subLobId}';
var CLIENT_AVAILABLE_BUS_API = '/api/orgConfig/clients/{id}/availableBusinessUnits?integrationId={integrationId}';
var CLIENT_BUS_API = '/api/orgConfig/clients/{id}/businessUnits';
var CLIENT_BU_API = '/api/orgConfig/clients/{id}/businessUnits/{buId}';
var CLIENT_IMPORT_BUS_API = '/api/orgConfig/clients/{id}/importBusinessUnits';
var CLIENT_INTEGRATION_API = '/api/orgConfig/clients/{id}/integrations/{integrationId}';
var CLIENT_INTEGRATION_RETEST_API = '/api/orgConfig/clients/{id}/integrations/{integrationId}/retest';
export var useClientsAPI = function (configVersionId) {
    return useAPI("".concat(CLIENTS_API, "?configVersionId={configVersionId}"), { configVersionId: configVersionId !== null && configVersionId !== void 0 ? configVersionId : 0 }, 'GET', { key: "orgConfigClients-".concat(configVersionId !== null && configVersionId !== void 0 ? configVersionId : 'none') });
};
export var useCreateClientAPI = function () { return useAuthenticatedAPI(CLIENTS_API, {}, 'POST'); };
export var useClientDetailAPI = function (id) {
    return useAPI(CLIENT_API, { id: id !== null && id !== void 0 ? id : 0 }, 'GET', {
        key: "orgConfigClientDetail-".concat(id !== null && id !== void 0 ? id : 'none'),
    });
};
export var useUpdateClientAPI = function (id) {
    return useAuthenticatedAPI(CLIENT_API, { id: id }, 'PUT', {
        key: "orgConfigClientUpdate-".concat(id),
    });
};
export var useDeleteClientAPI = function (id) {
    return useAuthenticatedAPI(CLIENT_API, { id: id }, 'DELETE', {
        key: "orgConfigClientDelete-".concat(id),
    });
};
export var useTestConnectionAPI = function () {
    return useAuthenticatedAPI(TEST_CONNECTION_API, {}, 'POST', {
        key: 'orgConfigTestConnection',
    });
};
export var useTestAndSaveConnectionAPI = function (id) {
    return useAuthenticatedAPI(CLIENT_TEST_API, { id: id }, 'POST', {
        key: "orgConfigClientTestSave-".concat(id),
    });
};
export var useClientLobsAPI = function (clientId, keyPrefix) {
    if (keyPrefix === void 0) { keyPrefix = 'orgConfigClientLobs'; }
    return useAPI(CLIENT_LOBS_API, { id: clientId !== null && clientId !== void 0 ? clientId : 0 }, 'GET', {
        key: "".concat(keyPrefix, "-").concat(clientId !== null && clientId !== void 0 ? clientId : 'none'),
    });
};
export var useCreateLobAPI = function (clientId) {
    return useAuthenticatedAPI(CLIENT_LOBS_API, { id: clientId }, 'POST', {
        key: "orgConfigCreateLob-".concat(clientId),
    });
};
export var useDeleteLobAPI = function (clientId, lobId) {
    return useAuthenticatedAPI(CLIENT_LOB_API, { id: clientId, lobId: lobId }, 'DELETE', {
        key: "orgConfigDeleteLob-".concat(clientId, "-").concat(lobId),
    });
};
export var useDeleteSubLobAPI = function (clientId, lobId, subLobId) {
    return useAuthenticatedAPI(CLIENT_SUB_LOB_API, { id: clientId, lobId: lobId, subLobId: subLobId }, 'DELETE', {
        key: "orgConfigDeleteSubLob-".concat(clientId, "-").concat(lobId, "-").concat(subLobId),
    });
};
// The lob id is supplied at call time via the trigger's `params` argument
// (e.g. updateLob(body, { lobId })), so only the client id is substituted here.
export var useUpdateLobAPI = function (clientId) {
    return useAuthenticatedAPI(CLIENT_LOB_API, { id: clientId }, 'PUT', {
        key: "orgConfigUpdateLob-".concat(clientId),
    });
};
export var useAvailableBusinessUnitsAPI = function (clientId, integrationId) {
    return useAPI(CLIENT_AVAILABLE_BUS_API, { id: clientId, integrationId: integrationId }, 'GET', {
        key: "orgConfigAvailableBusinessUnits-".concat(clientId, "-").concat(integrationId || 'none'),
    });
};
export var useDisconnectIntegrationAPI = function (clientId, integrationId) {
    return useAuthenticatedAPI(CLIENT_INTEGRATION_API, { id: clientId, integrationId: integrationId }, 'DELETE', {
        key: "orgConfigDisconnectIntegration-".concat(clientId, "-").concat(integrationId || 'none'),
    });
};
export var useRetestConnectionAPI = function (clientId, integrationId) {
    return useAuthenticatedAPI(CLIENT_INTEGRATION_RETEST_API, { id: clientId, integrationId: integrationId }, 'POST', {
        key: "orgConfigRetestIntegration-".concat(clientId, "-").concat(integrationId || 'none'),
    });
};
export var useClientsStatusAPI = function (configVersionId) {
    return useAPI("".concat(CLIENTS_STATUS_API, "?configVersionId={configVersionId}"), { configVersionId: configVersionId !== null && configVersionId !== void 0 ? configVersionId : 0 }, 'GET', { key: "clientsStatus-".concat(configVersionId !== null && configVersionId !== void 0 ? configVersionId : 'none') });
};
export var useClientBusinessUnitsAPI = function (clientId, keyPrefix) {
    if (keyPrefix === void 0) { keyPrefix = 'orgConfigClientBus'; }
    return useAPI(CLIENT_BUS_API, { id: clientId !== null && clientId !== void 0 ? clientId : 0 }, 'GET', {
        key: "".concat(keyPrefix, "-").concat(clientId !== null && clientId !== void 0 ? clientId : 'none'),
    });
};
export var useImportBusinessUnitsAPI = function (clientId) {
    return useAuthenticatedAPI(CLIENT_IMPORT_BUS_API, { id: clientId }, 'POST', {
        key: "orgConfigImportBus-".concat(clientId),
    });
};
export var useDeleteBusinessUnitAPI = function (clientId, buId) {
    return useAuthenticatedAPI(CLIENT_BU_API, { id: clientId, buId: buId }, 'DELETE', {
        key: "orgConfigDeleteBu-".concat(clientId, "-").concat(buId),
    });
};
